import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

const router = new Router({
  routes: []
});
router.onReady(() => {
  const dealResponse = (res) => {
    let keys = Object.keys(res);
    let r = [];
    keys.map(n => {
      //一级菜单
      console.log(res[n]);
      if (res[n]) {
        let firstLevel = res[n].apiHeadMenuVo;
        let title = firstLevel.title;
        let path = firstLevel.path;
        if (path === '/index') {
          path = '/';
        }
        let component = path == '/' ? 'Home' : path.charAt(1).toUpperCase() + path.substr(2);
        let item = {
          path,
          meta: { title },
          component: (resolve) => require(['@/components/Layout'], resolve),
          children: [{
            name: path,
            path: '',
            meta: { title },
            component: (resolve) => require([('@/views/' + component)], resolve),
          }],
          secodeLevel: []
        }
        //二级菜单
        if (res[n].resultMap.subMenuList) {
          let secondLevel = res[n].resultMap.subMenuList;
          item.query = `type=${secondLevel[0].type || secondLevel[0].id}`;
          secondLevel.map(o => {
            let title = o.title || o.name;
            let query = `type=${o.type || o.id}`;
            item.secodeLevel.push({ meta: { title }, query });
          })
        }
        r.push(item);
      }
    });
    r.push(
      {
        path: '/detail',
        meta: { title: localStorage.getItem('lang') === 'cn' ? '详情' : 'detail' },
        query: '',
        hide: true,
        component: () => import('@/components/Layout'),
        children: [
          {
            path: '',
            component: () => import('@/views/Detail')
          }
        ],
        secodeLevel: []
      },
      {
        path: '/about/introduction',
        meta: { title: localStorage.getItem('lang') === 'cn' ? '详情' : 'detail' },
        component: () => import('@/components/Layout'),
        hide: true,
        children: [
          {
            path: '',
            component: () => import('@/views/About/Introduction')
          }
        ],
        secodeLevel: []
      },
      {
        path: '*',
        meta: { title: localStorage.getItem('lang') === 'cn' ? '页面未找到' : 'Page Not Found' },
        query: '',
        hide: true,
        component: () => import('@/views/NoFound'),
        children: [],
        secodeLevel: []
      }
    )
    router.addRoutes(r);
    router.app.$options.store.commit('changeRouter', r);
  }
  //获取路由
  axios.get('index/abgwHomeMenuList', {
    language: 'zh-cn',
    deviceType: 2
  })
    .then(res => {
      dealResponse(res.data);
    })

});

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  NProgress.inc();
  if (to.meta && to.meta.title) {
    if (to.meta.title == '首页') {
      document.title = '湖南安邦制药股份有限公司'
    } else {
      document.title = to.meta.title
    }
  }
  next();
})

router.afterEach((router) => NProgress.done());

export default router;//导出路由